<template>
  <div class="upload-component text-left mb-2">
    <button class="btn btn-block p-0" @click="$emit('onClick')" type="button">
      <div class="dashed px-6 pt-5">
        <h6 class="text-primary d-flex align-items-center">
          <i :class="`icon-${icon} mr-3`"></i>{{ title }}
        </h6>
        <p class="text-muted text-left">{{ subTitle }}</p>
        <img
          v-if="stars"
          class="stars"
          src="@/assets/images/diagonal-stars.png"
        />
      </div>
    </button>

    <div v-if="form.title" class="solid px-6 pt-5 my-5">
      <h6 class="text-primary d-flex align-items-center">
        {{ title }}
      </h6>
      <p class="text-primary">{{ form.title }}</p>
    </div>
    <template>
      <slot />
    </template>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: "upload" //
    },
    title: {
      type: String,
      default: ""
    },
    subTitle: {
      type: String,
      default: ""
    },
    stars: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      visible: false,
      form: {
        title: "",
        url: ""
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.upload-component {
  position: relative;
  .dashed {
    position: relative;
    background-color: #f7f4fc;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    border-radius: 7px;
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='4' ry='4' stroke='%23D2D0D8FF' stroke-width='2' stroke-dasharray='8%2c 8' stroke-dashoffset='4' stroke-linecap='round'/%3e%3c/svg%3e");
    border-radius: 4px;
    cursor: pointer;
    width: 100%;
  }

  .stars {
    position: absolute;
    top: 10%;
    left: 2%;
    height: 35px;
  }

  .solid {
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 7px;
    border: 5px dashed #aaaaaa40;
    cursor: pointer;
    width: 100%;
  }

  p {
    font-weight: 500;
  }

  h6 {
    i {
      font-size: 24px;
    }
  }

  small {
    font-size: 9px !important;
  }

  input[type="file"] {
    position: absolute;
    opacity: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    cursor: pointer;
  }
  .text-muted {
    font-weight: 400;
    color: #928f98 !important;
  }
}
</style>
